import type { DownloadState } from '../core/types';

/** One vocabulary for state, reused everywhere so the interface teaches itself. */
export function stateLabel(state: DownloadState | undefined): string {
  switch (state) {
    case 'queued':
      return 'Waiting to start';
    case 'probing':
      return 'Checking the link';
    case 'active':
      return 'Downloading';
    case 'pausing':
      return 'Pausing';
    case 'paused':
      return 'Paused';
    case 'verifying':
      return 'Verifying';
    case 'complete':
      return 'Saved on this device';
    case 'recoverableError':
      return 'Stopped';
    case 'fatalError':
      return 'Cannot continue';
    case 'deleted':
      return 'Deleted';
    default:
      return '';
  }
}

export const MODE_COPY = {
  preview: {
    name: 'Preview priority',
    help: 'Keeps a connection free, so jumping ahead never waits behind the bulk download.',
  },
  balanced: {
    name: 'Balanced',
    help: 'Serves what you are watching or reading first, then fills in the rest.',
  },
  download: {
    name: 'Download priority',
    help: 'Uses every connection to finish sooner. Jumping ahead may wait a moment.',
  },
} as const;
